import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { transformErrorResponse } from 'helpers/errors';
import SearchUsersForm from 'components/SearchUsersForm';
import FormError from 'components/FormError';
import TransferDeviceForm from 'components/simo/TransferDeviceForm';
import { transferSimoDevice } from 'api';

class TransferSimoDevice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wasSearch: false,
      error: undefined,
      success: false,
      selected: undefined,
      loading: false,
    };
  }

  onSubmit = (values) => {
    const { simoDeviceId } = this.props;
    const { selected } = this.state;
    this.setState({ loading: true });
    return this.transferDevice(simoDeviceId, {
      ...values,
      user_profile: selected.id,
    });
  };

  handleSearch = (values) => {
    const { searchUsers } = this.props;
    return searchUsers(1, values).then(() =>
      this.setState({ wasSearch: true }),
    );
  };

  transferDevice = (simoDeviceId, attrs) => {
    return transferSimoDevice(simoDeviceId, attrs)
      .then((response) => {
        const { status } = response;
        if (status === 200 || status === 201) {
          this.setState({
            success: true,
            loading: false,
          });
        } else {
          throw response;
        }
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          const error = transformErrorResponse(err.response.data);
          this.setState({
            loading: false,
            error,
          });
        } else {
          this.setState({
            error: err,
            loading: false,
          });
        }
      });
  };

  selectUser(user) {
    if (user) {
      this.setState({
        selected: user,
      });
    }
  }

  render() {
    const { users, simoDeviceId, redirectUrl, loggedInUser, isAdminOrManager } =
      this.props;
    const { error, success, selected, loading, wasSearch } = this.state;

    if (success || (loggedInUser && !isAdminOrManager)) {
      return <Redirect to={redirectUrl(simoDeviceId)} />;
    }

    return (
      <div>
        <h1>Transfer Simo Device</h1>
        <div className="mar-b">
          <Link to={`/simo/devices/${simoDeviceId}/view`}>
            ← Back to Device
          </Link>
        </div>
        <SearchUsersForm
          onSubmit={this.handleSearch}
          fields={['email', 'first_name', 'last_name']}
        />
        {wasSearch && users && users.length > 0 && (
          <table className="table table-striped mar-t">
            <thead>
              <tr>
                <th>User ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Role</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr className="transfer-sub-users" key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.email}</td>
                  <td>{user.acl_group_name}</td>
                  <td>
                    <button
                      className={
                        selected && selected.id === user.id
                          ? 'btn btn-primary'
                          : 'btn btn-default'
                      }
                      onClick={() => this.selectUser(user)}
                    >
                      {selected && selected.id === user.id
                        ? 'Selected'
                        : 'Select'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {selected ? (
          selected.email ? (
            <TransferDeviceForm
              selected={selected}
              onSubmit={this.onSubmit}
              loading={loading}
            />
          ) : (
            <p>Users without email are ineligible for device transfer</p>
          )
        ) : null}
        {error && <FormError error={error} />}
        {wasSearch && users && users.length === 0 && (
          <div className="mar-t">No results</div>
        )}
      </div>
    );
  }
}

export default TransferSimoDevice;
